import type { PromptDataDto } from "../../types/PromptDataDto";
import type { PromptDataEntity } from "../../types/PromptDataEntity";

export const PromptDataDtoToEntity = ({ ...rest }: Readonly<PromptDataDto>): PromptDataEntity => {
    return {
        ...rest,
    };
};
